<template>
  <div class="animated fadeIn lunch-registration-page">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header page-header">
          <div class="header-primary">
            <div class="header-title-row">
              <h4 class="card-header-title">
                Đăng ký cơm trưa tháng {{ periodMonthDisplay }}
              </h4>
              <div class="period-picker">
                <el-select v-model="periodMode" @change="handlePeriodChange">
                  <!-- <template slot="prefix"
                    ><i class="fa fa-calendar"></i
                  ></template> -->
                  <el-option label="Tuần" value="week" />
                  <el-option label="Tháng" value="month" />
                </el-select>
              </div>
            </div>
            <p>
              Đăng ký cơm trước
              <strong>{{ registrationDeadline || "--:--" }}</strong> hằng ngày.
            </p>
          </div>
          <div class="header-actions">
            <button @click="goTo('/admin/lunch-registration-history')">
              <i class="fa fa-history"></i> Lịch sử đăng ký
            </button>
            <button v-if="canManageLunchMenu" @click="openSettingsDialog">
              <i class="fa fa-cog"></i> Cài đặt đăng ký cơm
            </button>
            <button
              v-if="canManageLunchMenu"
              @click="goTo('/admin/lunch-menu-schedule-management')"
            >
              <i class="fa fa-calendar"></i> Quản lý thực đơn
            </button>
            <button
              v-if="canViewLunchRegistrations"
              @click="goTo('/admin/lunch-registration-list')"
            >
              <i class="fa fa-list-alt"></i> Danh sách đăng ký
            </button>
          </div>
        </div>

        <div v-loading="loading" class="page-content">
          <div class="registration-layout">
            <main class="registration-main">
              <section
                v-if="periodMode === 'week'"
                class="panel registration-period-panel"
              >
                <div
                  v-if="
                    !loading &&
                    hasNoTodayRegistration &&
                    quickBannerVisible
                  "
                  class="quick-banner"
                >
                  <img
                    class="quick-banner__image"
                    :src="defaultMealImage"
                    alt="Cơm suất"
                  />
                  <div>
                    <strong>Bạn có muốn đăng ký cơm tuần này không?</strong
                    ><span
                      >Từ {{ formatDate(weekDays[0].dateKey) }} đến
                      {{ formatDate(weekDays[6].dateKey) }}</span
                    >
                  </div>
                  <div class="banner-actions">
                    <el-button
                      type="primary"
                      :disabled="bulkLoading || cancelWeekLoading"
                      @click="registerCurrentWeek"
                      ><i class="fa fa-calendar-check-o"></i> Đăng ký cả
                      tuần</el-button
                    >
                    <el-button @click="switchToMonth"
                      >Đăng ký cả tháng</el-button
                    >
                  </div>
                  <button
                    class="quick-banner__close"
                    type="button"
                    aria-label="Đóng thông báo"
                    @click="quickBannerVisible = false"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>

                <div class="section-head">
                  <div>
                    <h5>Đăng ký tuần này</h5>
                    <span>{{ weekRangeDisplay }}</span>
                  </div>
                  <div class="week-head-actions">
                    <div class="date-nav">
                      <button
                        aria-label="Tuần trước"
                        :disabled="weekLoading"
                        @click="changeWeek(-1)"
                      >
                        <i class="fa fa-angle-left"></i>
                      </button>
                      <button
                        class="date-nav__label"
                        :disabled="weekLoading"
                        @click="goToToday"
                      >
                        Hôm nay
                      </button>
                      <button
                        aria-label="Tuần sau"
                        :disabled="weekLoading"
                        @click="changeWeek(1)"
                      >
                        <i class="fa fa-angle-right"></i>
                      </button>
                    </div>
                    <el-button
                      type="primary"
                      :disabled="bulkLoading || cancelWeekLoading"
                      @click="registerCurrentWeek"
                      ><i class="fa fa-calendar-check-o"></i> Đăng ký cả
                      tuần</el-button
                    >
                    <el-button
                      plain
                      class="danger-button bulk-cancel-button"
                      :loading="cancelWeekLoading"
                      :disabled="
                        !weekRegisteredDates.length ||
                          cancelWeekLoading ||
                          bulkLoading
                      "
                      @click="cancelCurrentWeek"
                      ><i class="fa fa-calendar-times-o"></i> Hủy cả
                      tuần</el-button
                    >
                  </div>
                </div>

                <div id="lunch-week-grid" class="week-grid">
                  <article
                    v-for="day in weekDays"
                    :key="day.dateKey"
                    class="day-card"
                    :class="dayCardClass(day)"
                    tabindex="0"
                    @click="selectDate(day.dateKey)"
                    @keydown.enter="selectDate(day.dateKey)"
                  >
                    <strong>{{ day.weekday }}</strong
                    ><span>{{ formatShortDate(day.dateKey) }}</span>
                    <div class="day-card__status">
                      <span
                        v-if="day.isRegistered"
                        class="registered-status"
                      >
                        <i class="status status--ok fa fa-check"></i>
                        Đã đăng ký
                      </span>
                      <span
                        v-else-if="day.isRegistrationClosed"
                        class="deadline-status"
                        ><i class="fa fa-clock-o"></i><span>Hết hạn</span></span
                      >
                      <span v-else-if="day.isDayOff" class="day-off-status"
                        ><span>Ngày nghỉ</span
                        ><i class="fa fa-calendar-times-o"></i
                      ></span>
                      <span v-else>Chưa đăng ký</span>
                    </div>
                    <el-button
                      v-if="day.isRegistered"
                      size="small"
                      @click.stop="openRegistrationDialog(day.dateKey)"
                      >Sửa</el-button
                    >
                    <el-button
                      v-else-if="!day.isRegistrationClosed"
                      size="small"
                      class="registration-add-button"
                      @click.stop="openRegistrationDialog(day.dateKey)"
                      ><span class="registration-plus">+</span
                      ><span>Đăng ký</span></el-button
                    >
                  </article>
                </div>

                <div class="week-summary">
                  <span
                    >Tổng tiền tạm tính:
                    <strong>{{ formatCurrency(weekTotalAmount) }}</strong></span
                  >
                </div>
              </section>

              <section v-else class="panel registration-period-panel">
                <div class="section-head month-head">
                  <h5>Đăng ký {{ calendarMonthDisplay.toLowerCase() }}</h5>
                  <div class="month-actions">
                    <div class="date-nav">
                      <button
                        aria-label="Tháng trước"
                        :disabled="calendarLoading"
                        @click="changeMonth(-1)"
                      >
                        <i class="fa fa-angle-left"></i>
                      </button>
                      <el-date-picker
                        :value="calendarDate"
                        type="month"
                        format="[Tháng] MM/yyyy"
                        :clearable="false"
                        :editable="false"
                        :disabled="calendarLoading"
                        class="date-nav__month-picker"
                        popper-class="lunch-month-picker-popper"
                        aria-label="Chọn tháng đăng ký cơm"
                        @input="selectCalendarMonth"
                      />
                      <button
                        aria-label="Tháng sau"
                        :disabled="calendarLoading"
                        @click="changeMonth(1)"
                      >
                        <i class="fa fa-angle-right"></i>
                      </button>
                    </div>
                    <el-button
                      type="primary"
                      :disabled="bulkLoading || cancelMonthLoading"
                      @click="openMonthConfirmation"
                      ><i class="fa fa-calendar-check-o"></i> Đăng ký cả
                      tháng</el-button
                    >
                    <el-button
                      plain
                      class="danger-button month-cancel-button bulk-cancel-button"
                      :loading="cancelMonthLoading"
                      :disabled="
                        !monthRegisteredCount || cancelMonthLoading || bulkLoading
                      "
                      @click="cancelMonthDialogVisible = true"
                      ><i class="fa fa-calendar-times-o"></i> Hủy cả
                      tháng</el-button
                    >
                  </div>
                </div>

                <div class="calendar">
                  <div class="calendar-weekdays">
                    <span v-for="weekday in calendarWeekdays" :key="weekday">{{
                      weekday
                    }}</span>
                  </div>
                  <div class="calendar-grid">
                    <button
                      v-for="day in calendarDays"
                      :key="day.key || day.placeholderKey"
                      class="calendar-day"
                      :class="calendarDayClass(day)"
                      :disabled="day.isPlaceholder"
                      @click="openCalendarDay(day)"
                    >
                      <strong>{{ day.day }}</strong>
                      <i
                        v-if="day.isRegistered"
                        class="status status--ok fa fa-check"
                        aria-label="Đã đăng ký"
                      ></i>
                      <span v-else-if="day.isDayOff">Ngày nghỉ</span>
                      <span
                        v-else-if="day.isToday && !day.isRegistrationClosed"
                        class="today-text"
                        >Hôm nay</span
                      >
                    </button>
                  </div>
                </div>
                <div class="calendar-footer">
                  <div class="legend">
                    <span
                      ><i class="status status--ok fa fa-check"></i> Đã đăng
                      ký</span
                    >
                    <span
                      ><i class="legend-off fa fa-calendar-o"></i> Ngày
                      nghỉ</span
                    >
                  </div>
                  <div class="month-total">
                    <span
                      >Đã đăng ký:
                      <strong>{{ monthRegisteredCount }} ngày</strong></span
                    ><span
                      >Tổng tiền tạm tính:
                      <strong>{{
                        formatCurrency(monthTotalAmount)
                      }}</strong></span
                    >
                  </div>
                </div>
              </section>
            </main>

            <aside class="panel meal-panel">
              <div class="meal-head">
                <div>
                  <h5>Suất ăn của bạn</h5>
                  <span>{{ selectedDateDisplay }}</span>
                </div>
                <span v-if="hasRegistration" class="pill pill--ok"
                  ><i class="fa fa-check"></i> Đã đăng ký</span
                >
                <span v-else-if="isSelectedDayOff" class="pill"
                  ><i class="fa fa-calendar-o"></i> Ngày nghỉ</span
                >
              </div>
              <div v-if="hasRegistration" class="meal-body">
                <div class="meal-table">
                  <div class="meal-table__header">
                    <span>Tên món</span>
                    <span>Đơn giá</span>
                    <span>Số lượng</span>
                  </div>
                  <div class="meal-table__list">
                    <div
                      v-for="item in registeredMealItems"
                      :key="item.foodId"
                      class="meal-table__row"
                    >
                      <div class="meal-table__name">
                        <strong>{{ item.foodName }}</strong>
                        <span v-if="isDefaultMealName(item.foodName)"
                          >(mặc định)</span
                        >
                      </div>
                      <strong class="meal-table__price">{{
                        formatCurrency(item.price)
                      }}</strong>
                      <strong
                        class="meal-table__quantity"
                        :aria-label="`Số lượng ${item.quantity}`"
                        >{{ item.quantity }}</strong
                      >
                    </div>
                  </div>
                </div>
                <label class="meal-note-label">Ghi chú (tùy chọn)</label>
                <div
                  class="meal-note-display"
                  :class="{ 'meal-note-display--empty': !currentRegistration.note }"
                  v-text="currentRegistration.note || 'Không có ghi chú'"
                ></div>
                <div class="meal-total">
                  <span>Tổng tiền</span>
                  <strong>{{
                    formatCurrency(currentRegistration.totalAmount)
                  }}</strong>
                </div>
                <div class="meal-actions">
                  <el-button
                    type="primary"
                    class="meal-action-button meal-action-button--edit"
                    @click="handleEditRegistration"
                    ><i class="fa fa-pencil"></i> Sửa đăng ký</el-button
                  >
                  <el-button
                    plain
                    class="danger-button meal-action-button meal-action-button--cancel"
                    @click="cancelRegistration"
                    ><i class="fa fa-trash-o"></i> Hủy đăng ký</el-button
                  >
                </div>
              </div>
              <div v-else-if="isSelectedRegistrationClosed" class="expired-meal">
                <i class="fa fa-clock-o"></i>
                <div>
                  <strong>{{ registrationClosedMessage }}</strong>
                  <span v-if="isSelectedToday"
                    >Hạn đăng ký: {{ registrationDeadline }}</span
                  >
                </div>
              </div>
              <div v-else class="empty-meal">
                <div>
                  <strong v-if="isSelectedDayOff">Đây là ngày nghỉ.</strong
                  ><span>Chưa đăng ký cơm.</span>
                </div>
                <el-button
                  type="primary"
                  class="registration-add-button"
                  @click="openRegistrationDialog(selectedDate)"
                  ><span class="registration-plus">+</span
                  ><span>Đăng ký cơm</span></el-button
                >
              </div>
            </aside>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="registrationDialogTitle"
      :visible.sync="registrationDialogVisible"
      width="760px"
      custom-class="lunch-dialog lunch-registration-dialog"
      append-to-body
      :close-on-click-modal="false"
    >
      <div v-if="isSelectedDayOff" class="notice">
        <i class="fa fa-info-circle"></i
        ><span>Đây là ngày nghỉ. Bạn đang đăng ký cơm riêng cho ngày này.</span>
      </div>
      <div v-if="!currentMenu.length" class="empty-state">
        Chưa có thực đơn cho ngày này.
      </div>
      <template v-else>
        <div class="registration-section-heading">
          <div>
            <h6>Danh sách món ăn</h6>
            <p>Chọn món ăn cho suất cơm của bạn</p>
          </div>
          <span>{{ selectedFoods.length }} món đã chọn</span>
        </div>
        <div class="food-grid">
          <button
            v-for="food in currentMenu"
            :key="food.id"
            class="food-card"
            :class="{ selected: isFoodSelected(food.id) }"
            :aria-pressed="isFoodSelected(food.id)"
            @click="toggleFood(food.id)"
          >
            <div>
              <img :src="food.image" :alt="food.name" /><i
                v-if="isFoodSelected(food.id)"
                class="fa fa-check"
              ></i>
            </div>
            <strong>{{ food.name }}</strong
            ><span>{{ formatCurrency(food.price) }}</span>
          </button>
        </div>
        <div v-if="selectedFoods.length" class="order-options">
          <div class="order-options__heading">
            <strong>Món đã chọn</strong>
          </div>
          <div class="selected-food-table">
            <div class="selected-food-table__header">
              <span>Tên món</span>
              <span>Đơn giá</span>
              <span>Số lượng</span>
            </div>
            <div class="selected-food-table__list">
              <div
                v-for="food in selectedFoods"
                :key="food.id"
                class="quantity-row"
              >
                <div class="selected-food-name">
                  <strong>{{ food.name }}</strong>
                  <span v-if="isDefaultMealName(food.name)">(mặc định)</span>
                </div>
                <strong class="selected-food-price">{{
                  formatCurrency(food.price)
                }}</strong>
                <div class="quantity-control">
                  <div class="quantity-display quantity-editor">
                    <button
                      type="button"
                      aria-label="Giảm số lượng"
                      :disabled="(selectedFoodQuantities[food.id] || 1) <= 1"
                      @click="
                        setFoodQuantity(
                          food.id,
                          (selectedFoodQuantities[food.id] || 1) - 1
                        )
                      "
                    >
                      −
                    </button>
                    <span>{{ selectedFoodQuantities[food.id] || 1 }}</span>
                    <button
                      type="button"
                      aria-label="Tăng số lượng"
                      :disabled="(selectedFoodQuantities[food.id] || 1) >= 20"
                      @click="
                        setFoodQuantity(
                          food.id,
                          (selectedFoodQuantities[food.id] || 1) + 1
                        )
                      "
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="dialog-note-field">
            <label for="registration-note">Ghi chú (tùy chọn)</label>
            <el-input
              id="registration-note"
              v-model="note"
              maxlength="200"
              placeholder="Ví dụ: Ít cơm, không hành..."
            />
          </div>
          <div class="dialog-total">
            <span>Tổng tiền</span
            ><strong>{{ formatCurrency(totalPrice) }}</strong>
          </div>
        </div>
      </template>
      <span slot="footer" class="dialog-footer"
        ><el-button @click="registrationDialogVisible = false">Đóng</el-button
        ><el-button
          type="primary"
          :loading="savingRegistration"
          :disabled="!selectedFoods.length"
          @click="submitRegistration"
          >{{ hasRegistration ? "Lưu thay đổi" : "Đăng ký" }}</el-button
        ></span
      >
    </el-dialog>

    <el-dialog
      title="Cài đặt đăng ký cơm"
      :visible.sync="settingsDialogVisible"
      width="460px"
      custom-class="lunch-dialog lunch-settings-dialog"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="settings-form">
        <h5>Hạn đăng ký cơm hằng ngày</h5>
        <label>Đăng ký trước</label>
        <el-time-picker
          v-model="registrationDeadlineDraft"
          format="HH:mm"
          value-format="HH:mm"
          :clearable="false"
          placeholder="Chọn giờ"
        />
        <p>
          Sau thời gian này, nhân viên không thể đăng ký cơm cho ngày hiện tại.
        </p>
        <p>Việc đăng ký cho các ngày trong tương lai vẫn hoạt động bình thường.</p>

        <div style="margin-top: 20px; padding-top: 16px; border-top: 1px solid #ebeef5;">
          <h5 style="margin-bottom: 8px;">Tự động đặt cơm tuần mới</h5>
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <span style="font-size: 13px; color: #4b5563; flex: 1; padding-right: 12px;">
              Tự động đặt “Cơm suất” cho cả tuần tới vào 18:00 Chủ Nhật nếu nhân viên chưa chủ động đăng ký
            </span>
            <el-switch
              v-model="autoRegisterDefaultDraft"
              active-color="#10B981"
              inactive-color="#D1D5DB"
            />
          </div>
          <p style="font-size: 12px; color: #6b7280; margin-top: 6px;">
            Nhân viên vẫn có thể bấm vào lịch để thay đổi món ăn hoặc hủy suất bất cứ lúc nào trước hạn chốt hằng ngày.
          </p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer"
        ><el-button @click="settingsDialogVisible = false">Hủy</el-button
        ><el-button
          type="primary"
          :loading="savingSettings"
          @click="saveSettings"
          >Lưu thay đổi</el-button
        ></span
      >
    </el-dialog>

    <el-dialog
      :title="`Hủy đăng ký cơm ${calendarMonthDisplay.toLowerCase()}?`"
      :visible.sync="cancelMonthDialogVisible"
      width="500px"
      custom-class="lunch-dialog lunch-cancel-month-dialog"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="!cancelMonthLoading"
      :show-close="!cancelMonthLoading"
    >
      <div class="cancel-month-confirmation">
        Bạn có chắc muốn hủy các ngày đã đăng ký trong
        {{ calendarMonthDisplay.toLowerCase() }} không?
        <p>
          Những ngày đã quá hạn sửa hoặc hủy sẽ được giữ nguyên.
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          :disabled="cancelMonthLoading"
          @click="cancelMonthDialogVisible = false"
          >Không</el-button
        >
        <el-button
          plain
          class="danger-button"
          :loading="cancelMonthLoading"
          :disabled="cancelMonthLoading"
          @click="confirmMonthCancellation"
          >Hủy đăng ký</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="`Xác nhận đăng ký cơm ${calendarMonthDisplay.toLowerCase()}`"
      :visible.sync="monthConfirmationVisible"
      width="560px"
      custom-class="lunch-dialog lunch-month-confirmation-dialog"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="month-confirm">
        <p class="month-default-meal-note">
          Món ăn mặc định được đăng ký là <strong>“Cơm suất”</strong>. Bạn có
          thể thay đổi cho từng ngày bằng cách bấm vào ngày trong lịch.
        </p>
        <div class="confirm-stats">
          <span
            ><i class="fa fa-calendar"></i
            ><strong>{{ monthWorkingDays.length }}</strong> ngày làm việc</span
          ><span
            ><i class="fa fa-cutlery"></i
            ><strong>{{ preparedBulkPlan.length }}</strong> suất sẽ đăng
            ký</span
          ><span
            ><i class="fa fa-money"></i>Tổng dự kiến:
            <strong>{{ formatCurrency(preparedBulkTotal) }}</strong></span
          >
        </div>
        <div class="notice month-registration-notice">
          <i class="fa fa-info-circle"></i
          ><span
            >Thứ 7, Chủ nhật và ngày nghỉ sẽ không được đăng ký tự động. Bạn vẫn
            có thể đăng ký riêng từng ngày nếu đi làm.</span
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer"
        ><el-button @click="monthConfirmationVisible = false"
          >Quay lại</el-button
        ><el-button
          type="primary"
          :loading="bulkLoading"
          :disabled="!preparedBulkPlan.length"
          @click="confirmMonthRegistration"
          >Xác nhận đăng ký</el-button
        ></span
      >
    </el-dialog>
  </div>
</template>

<script>
import MethodService from "@/service/MethodService";
import LunchApi from "./lunchApiService";
import { getDefaultFoodImage } from "./lunchFoodAssets";

const WEEKDAYS = [
  "Chủ Nhật",
  "Thứ Hai",
  "Thứ Ba",
  "Thứ Tư",
  "Thứ Năm",
  "Thứ Sáu",
  "Thứ Bảy"
];
const CALENDAR_WEEKDAYS = [
  "Thứ Hai",
  "Thứ Ba",
  "Thứ Tư",
  "Thứ Năm",
  "Thứ Sáu",
  "Thứ Bảy",
  "Chủ Nhật"
];

export default {
  name: "LunchRegistration",
  data() {
    const today = this.formatDateKey(new Date());
    const requestedWeekStart =
      this.$route &&
      this.$route.query &&
      typeof this.$route.query.weekStart === "string"
        ? this.$route.query.weekStart
        : "";
    const initialDate =
      /^\d{4}-\d{2}-\d{2}$/.test(requestedWeekStart) &&
      this.formatDateKey(this.createDate(requestedWeekStart)) ===
        requestedWeekStart
        ? requestedWeekStart
        : today;
    return {
      periodMode: "week",
      selectedDate: initialDate,
      lastCalendarClickDate: "",
      weekAnchor: this.createDate(initialDate),
      calendarDate: this.createDate(initialDate),
      currentMenu: [],
      menuCache: {},
      selectedFoodIds: [],
      selectedFoodQuantities: {},
      note: "",
      registrationSummaries: [],
      currentRegistration: null,
      dateMetadata: {},
      loading: false,
      weekLoading: false,
      calendarLoading: false,
      savingRegistration: false,
      bulkLoading: false,
      cancelWeekLoading: false,
      registrationDeadline: "",
      registrationDeadlineDraft: "",
      autoRegisterDefault: false,
      autoRegisterDefaultDraft: false,
      settingsDialogVisible: false,
      savingSettings: false,
      clockTick: Date.now(),
      clockTimer: null,
      quickBannerVisible: true,
      loadedRegistrationMonths: {},
      registrationDialogVisible: false,
      monthConfirmationVisible: false,
      cancelMonthDialogVisible: false,
      cancelMonthLoading: false,
      preparedBulkPlan: []
    };
  },
  computed: {
    calendarWeekdays() {
      return CALENDAR_WEEKDAYS;
    },
    periodMonthDisplay() {
      const date =
        this.periodMode === "month" ? this.calendarDate : this.weekAnchor;
      return `${date.getMonth() + 1}/${date.getFullYear()}`;
    },
    calendarMonthDisplay() {
      return `Tháng ${String(this.calendarDate.getMonth() + 1).padStart(
        2,
        "0"
      )}/${this.calendarDate.getFullYear()}`;
    },
    selectedDateDisplay() {
      const date = this.createDate(this.selectedDate);
      return `${WEEKDAYS[date.getDay()]}, ${this.formatDate(
        this.selectedDate
      )}`;
    },
    weekStart() {
      const date = new Date(this.weekAnchor);
      date.setHours(0, 0, 0, 0);
      date.setDate(date.getDate() - ((date.getDay() + 6) % 7));
      return date;
    },
    weekDays() {
      return Array.from({ length: 7 }, (_, index) => {
        const date = new Date(this.weekStart);
        date.setDate(date.getDate() + index);
        return this.buildDayModel(this.formatDateKey(date));
      });
    },
    weekRangeDisplay() {
      return `${this.formatDate(this.weekDays[0].dateKey)} - ${this.formatDate(
        this.weekDays[6].dateKey
      )}`;
    },
    isPastWeek() {
      const lastDay = this.weekDays[this.weekDays.length - 1];
      return Boolean(
        lastDay && lastDay.dateKey < this.getBusinessClock().dateKey
      );
    },
    workingWeekDays() {
      return this.weekDays.filter(day => day.isWorkingDay);
    },
    weekWorkingRegisteredCount() {
      return this.workingWeekDays.filter(day => day.isRegistered).length;
    },
    hasNoTodayRegistration() {
      const today = this.getBusinessClock().dateKey;
      if (!this.loadedRegistrationMonths[today.slice(0, 7)]) return false;
      const registration = this.findSummary(today);
      return !registration || registration.status === "CANCELLED";
    },
    weekRegisteredDates() {
      return this.weekDays
        .filter(day => day.isRegistered)
        .map(day => day.dateKey);
    },
    weekTotalAmount() {
      return this.weekDays.reduce(
        (sum, day) =>
          sum +
          (day.isRegistered
            ? Number(day.summary.total_amount || day.summary.totalAmount || 0)
            : 0),
        0
      );
    },
    calendarDays() {
      const year = this.calendarDate.getFullYear(),
        month = this.calendarDate.getMonth();
      const firstOffset = (new Date(year, month, 1).getDay() + 6) % 7;
      const days = Array.from({ length: firstOffset }, (_, index) => ({
        isPlaceholder: true,
        placeholderKey: `blank-${year}-${month}-${index}`
      }));
      for (let day = 1; day <= new Date(year, month + 1, 0).getDate(); day += 1)
        days.push(
          this.buildDayModel(
            this.formatDateKey(new Date(year, month, day)),
            day
          )
        );
      return days;
    },
    monthWorkingDays() {
      return this.calendarDays.filter(
        day => !day.isPlaceholder && day.isWorkingDay
      );
    },
    monthRegisteredCount() {
      return this.calendarDays.filter(
        day => !day.isPlaceholder && day.isRegistered
      ).length;
    },
    monthTotalAmount() {
      return this.calendarDays.reduce(
        (sum, day) =>
          sum +
          (!day.isPlaceholder && day.isRegistered
            ? Number(day.summary.total_amount || day.summary.totalAmount || 0)
            : 0),
        0
      );
    },
    selectedFoods() {
      const selected = new Set(this.selectedFoodIds);
      return this.currentMenu
        .filter(food => selected.has(food.id))
        .map(food => ({
          ...food,
          quantity: this.selectedFoodQuantities[food.id] || 1
        }));
    },
    totalPrice() {
      return this.selectedFoods.reduce(
        (sum, food) => sum + food.price * food.quantity,
        0
      );
    },
    hasRegistration() {
      return Boolean(
        this.currentRegistration &&
          this.currentRegistration.status !== "CANCELLED"
      );
    },
    isSelectedDayOff() {
      return !this.isWorkingDate(this.selectedDate);
    },
    isSelectedToday() {
      return this.selectedDate === this.getBusinessClock().dateKey;
    },
    isSelectedRegistrationClosed() {
      return !this.hasRegistration && this.isRegistrationClosed(this.selectedDate);
    },
    registrationClosedMessage() {
      return this.isSelectedToday
        ? "Đã hết thời gian đăng ký hôm nay."
        : "Không thể đăng ký cơm cho ngày đã qua.";
    },
    canEditCurrentRegistration() {
      return (
        this.hasRegistration &&
        !this.isRegistrationClosed(this.selectedDate) &&
        this.currentRegistration.can_edit !== false
      );
    },
    canCancelCurrentRegistration() {
      return (
        this.hasRegistration &&
        !this.isRegistrationClosed(this.selectedDate) &&
        this.currentRegistration.can_cancel !== false
      );
    },
    registeredMealItems() {
      if (!this.hasRegistration) return [];
      return this.currentRegistration.items.map(item => {
        const food =
          this.currentMenu.find(value => value.id === item.foodId) || {};
        return {
          ...item,
          foodName: item.foodName || food.name || "Món ăn",
          description: food.description || "",
          image: food.image || getDefaultFoodImage(item.category),
          price: item.price || food.price || 0
        };
      });
    },
    defaultMealImage() {
      const defaultFood = this.findDefaultMeal(this.currentMenu);
      if (defaultFood && defaultFood.image) return defaultFood.image;
      if (this.registeredMealItems.length)
        return this.registeredMealItems[0].image;
      return getDefaultFoodImage("Món mặn");
    },
    registrationDialogTitle() {
      return `${this.hasRegistration ? "Sửa đăng ký" : "Đăng ký cơm"} - ${
        this.selectedDateDisplay
      }`;
    },
    preparedBulkTotal() {
      return this.preparedBulkPlan.reduce(
        (sum, item) => sum + Number(item.food.price || 0),
        0
      );
    },
    canManageLunchMenu() {
      return MethodService.checkHaveFeature("FT2402");
    },
    canViewLunchRegistrations() {
      return MethodService.checkHaveFeature("FT2403");
    },
    hasLunchManagementActions() {
      return this.canManageLunchMenu || this.canViewLunchRegistrations;
    }
  },
  watch: {
    async "$route.query.weekStart"(weekStart) {
      if (
        typeof weekStart !== "string" ||
        !/^\d{4}-\d{2}-\d{2}$/.test(weekStart) ||
        this.formatDateKey(this.createDate(weekStart)) !== weekStart ||
        this.formatDateKey(this.weekStart) === weekStart
      )
        return;

      this.periodMode = "week";
      this.selectedDate = weekStart;
      this.weekAnchor = this.createDate(weekStart);
      this.calendarDate = this.createDate(weekStart);
      this.loading = true;
      try {
        await this.loadWeekData();
        await this.loadSelectedDateData();
      } finally {
        this.loading = false;
      }
    }
  },
  async created() {
    this.loading = true;
    try {
      await Promise.all([this.loadSettings(), this.loadWeekData()]);
      await this.loadSelectedDateData();
    } finally {
      this.loading = false;
    }
  },
  mounted() {
    this.clockTimer = window.setInterval(() => {
      this.clockTick = Date.now();
    }, 30000);
  },
  beforeDestroy() {
    if (this.clockTimer) window.clearInterval(this.clockTimer);
  },
  methods: {
    goTo(path) {
      this.$router.push({ path }).catch(() => {});
    },
    createDate(key) {
      const p = key.split("-").map(Number);
      return new Date(p[0], p[1] - 1, p[2]);
    },
    formatDateKey(date) {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(date.getDate()).padStart(2, "0")}`;
    },
    formatMonthKey(date) {
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}`;
    },
    formatDate(key) {
      if (!key) return "";
      const p = key.split("-");
      return `${p[2]}/${p[1]}/${p[0]}`;
    },
    formatShortDate(key) {
      const p = key.split("-");
      return `${p[2]}/${p[1]}`;
    },
    formatCurrency(value) {
      return `${Number(value || 0).toLocaleString("vi-VN")} đ`;
    },
    getBusinessClock() {
      const date = new Date(this.clockTick + 7 * 60 * 60 * 1000);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      return {
        dateKey: `${year}-${month}-${day}`,
        minutes: date.getUTCHours() * 60 + date.getUTCMinutes()
      };
    },
    deadlineMinutes() {
      if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(this.registrationDeadline))
        return null;
      const parts = this.registrationDeadline.split(":").map(Number);
      return parts[0] * 60 + parts[1];
    },
    isRegistrationClosed(key) {
      const clock = this.getBusinessClock();
      if (key < clock.dateKey) return true;
      if (key > clock.dateKey) return false;
      const deadline = this.deadlineMinutes();
      return deadline !== null && clock.minutes >= deadline;
    },
    getMetadata(key) {
      return this.dateMetadata[key] || null;
    },
    isWeekend(key) {
      const m = this.getMetadata(key);
      if (m && m.is_weekend !== undefined) return m.is_weekend;
      const day = this.createDate(key).getDay();
      return day === 0 || day === 6;
    },
    isHoliday(key) {
      const m = this.getMetadata(key);
      return Boolean(m && m.is_holiday);
    },
    isWorkingDate(key) {
      const m = this.getMetadata(key);
      return m && m.is_working_day !== undefined
        ? m.is_working_day
        : !this.isWeekend(key);
    },
    findSummary(key) {
      return this.registrationSummaries.find(item => item.date === key) || null;
    },
    buildDayModel(key, number) {
      const date = this.createDate(key),
        summary = this.findSummary(key),
        isWorkingDay = this.isWorkingDate(key);
      return {
        key,
        dateKey: key,
        day: number || date.getDate(),
        weekday: WEEKDAYS[date.getDay()],
        summary,
        isRegistered: Boolean(summary && summary.status !== "CANCELLED"),
        isWorkingDay,
        isDayOff: !isWorkingDay,
        isWeekend: this.isWeekend(key),
        isHoliday: this.isHoliday(key),
        isToday: key === this.getBusinessClock().dateKey,
        isRegistrationClosed: this.isRegistrationClosed(key),
        isSelected: key === this.selectedDate,
        isPlaceholder: false
      };
    },
    dayCardClass(day) {
      return {
        selected: day.isSelected,
        registered: day.isRegistered,
        "day-off": day.isDayOff,
        expired: day.isRegistrationClosed && !day.isRegistered,
        today: day.isToday
      };
    },
    calendarDayClass(day) {
      return {
        placeholder: day.isPlaceholder,
        selected: day.isSelected,
        registered: day.isRegistered,
        "day-off": day.isDayOff,
        expired: day.isRegistrationClosed && !day.isRegistered,
        today: day.isToday
      };
    },
    mergeMonthData(month, metadata, registrations) {
      Object.keys(this.dateMetadata).forEach(key => {
        if (key.indexOf(`${month}-`) === 0)
          this.$delete(this.dateMetadata, key);
      });
      (metadata || []).forEach(item => {
        if (item && item.date) this.$set(this.dateMetadata, item.date, item);
      });
      this.registrationSummaries = this.registrationSummaries
        .filter(item => item.date.indexOf(`${month}-`) !== 0)
        .concat(registrations || []);
    },
    async loadMonthKeyData(month) {
      try {
        const result = await Promise.all([
          LunchApi.getValidDates(month),
          LunchApi.listMyRegistrations(month)
        ]);
        this.mergeMonthData(
          month,
          result[0].dates || [],
          result[1].registrations || []
        );
        this.$set(this.loadedRegistrationMonths, month, true);
      } catch (error) {
        this.showApiError(error, "Không tải được dữ liệu lịch đăng ký cơm.");
      }
    },
    async loadSettings() {
      try {
        const settings = await LunchApi.getSettings();
        this.registrationDeadline = settings.registration_deadline || "";
        this.autoRegisterDefault =
          typeof settings.auto_register_default === "boolean"
            ? settings.auto_register_default
            : false;
      } catch (error) {
        this.showApiError(error, "Không tải được hạn đăng ký cơm.");
      }
    },
    openSettingsDialog() {
      this.registrationDeadlineDraft = this.registrationDeadline;
      this.autoRegisterDefaultDraft = this.autoRegisterDefault;
      this.settingsDialogVisible = true;
    },
    async saveSettings() {
      if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(this.registrationDeadlineDraft)) {
        this.showToast("warning", "Hạn đăng ký phải có định dạng HH:mm hợp lệ.");
        return;
      }
      this.savingSettings = true;
      try {
        const settings = await LunchApi.updateSettings(
          this.registrationDeadlineDraft,
          this.autoRegisterDefaultDraft
        );
        this.registrationDeadline = settings.registration_deadline;
        this.registrationDeadlineDraft = settings.registration_deadline;
        if (typeof settings.auto_register_default === "boolean") {
          this.autoRegisterDefault = settings.auto_register_default;
          this.autoRegisterDefaultDraft = settings.auto_register_default;
        }
        this.clockTick = Date.now();
        await this.loadSelectedDateData();
        this.settingsDialogVisible = false;
        this.showToast("success", "Đã cập nhật cài đặt đăng ký cơm.");
      } catch (error) {
        this.showApiError(error, "Không cập nhật được cài đặt đăng ký cơm.");
      } finally {
        this.savingSettings = false;
      }
    },
    async loadWeekData(anchor = this.weekAnchor) {
      const weekStart = new Date(anchor);
      weekStart.setHours(0, 0, 0, 0);
      weekStart.setDate(weekStart.getDate() - ((weekStart.getDay() + 6) % 7));
      const weekMonths = Array.from({ length: 7 }, (_, index) => {
        const date = new Date(weekStart);
        date.setDate(date.getDate() + index);
        return this.formatDateKey(date).slice(0, 7);
      });
      await Promise.all(
        [
          ...new Set([
            this.getBusinessClock().dateKey.slice(0, 7),
            ...weekMonths
          ])
        ].map(month => this.loadMonthKeyData(month))
      );
    },
    async loadCalendarData(date = this.calendarDate) {
      await this.loadMonthKeyData(this.formatMonthKey(date));
    },
    async loadMenuByDate(key) {
      if (this.menuCache[key]) return this.menuCache[key];
      const result = await LunchApi.getMenuDetail(key);
      const foods = result.foods || [];
      this.$set(this.menuCache, key, foods);
      return foods;
    },
    async loadRegistrationByDate(key) {
      const summary = this.findSummary(key);
      return !summary || summary.status === "CANCELLED"
        ? null
        : LunchApi.getMyRegistration(key);
    },
    applyDraft() {
      const items = this.hasRegistration ? this.currentRegistration.items : [];
      this.selectedFoodIds = items
        .map(item => item.foodId)
        .filter(id => this.currentMenu.some(food => food.id === id));
      this.selectedFoodQuantities = items.reduce((result, item) => {
        if (this.selectedFoodIds.includes(item.foodId))
          result[item.foodId] = item.quantity || 1;
        return result;
      }, {});
      this.note = this.hasRegistration
        ? this.currentRegistration.note || ""
        : "";
      if (!this.selectedFoodIds.length) {
        const food = this.findDefaultMeal(this.currentMenu);
        if (food) {
          this.selectedFoodIds = [food.id];
          this.$set(this.selectedFoodQuantities, food.id, 1);
        }
      }
    },
    async loadSelectedDateData() {
      try {
        const result = await Promise.all([
          this.loadMenuByDate(this.selectedDate),
          this.loadRegistrationByDate(this.selectedDate)
        ]);
        this.currentMenu = result[0];
        this.currentRegistration = result[1];
        this.applyDraft();
      } catch (error) {
        this.currentMenu = [];
        this.currentRegistration = null;
        this.selectedFoodIds = [];
        this.selectedFoodQuantities = {};
        this.note = "";
        this.showApiError(
          error,
          "Không tải được thông tin suất ăn ngày đã chọn."
        );
      }
    },
    async selectDate(key) {
      if (!key) return;
      this.selectedDate = key;
      await this.loadSelectedDateData();
    },
    async openRegistrationDialog(key) {
      this.loading = true;
      await this.selectDate(key);
      this.loading = false;
      if (this.hasRegistration && !this.canEditCurrentRegistration) {
        this.showModificationDeadlineAlert();
        return;
      }
      if (!this.hasRegistration && this.isRegistrationClosed(key)) {
        this.showToast(
          "warning",
          key === this.getBusinessClock().dateKey
            ? `Đã hết hạn đăng ký hôm nay lúc ${this.registrationDeadline}.`
            : "Không thể đăng ký cơm cho ngày đã qua."
        );
        return;
      }
      this.registrationDialogVisible = true;
    },
    handleEditRegistration() {
      if (!this.canEditCurrentRegistration) {
        this.showModificationDeadlineAlert();
        return;
      }
      this.registrationDialogVisible = true;
    },
    showModificationDeadlineAlert() {
      const message = `Đã quá hạn đăng ký, không thể sửa/hủy suất ăn. Hạn đăng ký: ${this.registrationDeadline}.`;
      if (this.$alert) {
        this.$alert(message, "Đã quá hạn đăng ký", {
          confirmButtonText: "Đã hiểu",
          type: "warning"
        }).catch(() => {});
      } else {
        window.alert(message);
      }
    },
    async openCalendarDay(day) {
      if (!day || day.isPlaceholder) return;
      const isSecondClick = this.lastCalendarClickDate === day.dateKey;
      this.lastCalendarClickDate = day.dateKey;
      if (!isSecondClick) {
        await this.selectDate(day.dateKey);
        return;
      }
      await this.openRegistrationDialog(day.dateKey);
    },
    async handlePeriodChange(mode) {
      this.lastCalendarClickDate = "";
      this.loading = true;
      try {
        if (mode === "month") {
          this.calendarDate = this.createDate(this.selectedDate);
          await this.loadCalendarData();
        } else {
          this.weekAnchor = this.createDate(this.selectedDate);
          await this.loadWeekData();
        }
      } finally {
        this.loading = false;
      }
    },
    switchToMonth() {
      this.periodMode = "month";
      this.handlePeriodChange("month");
    },
    async changeWeek(offset) {
      if (this.weekLoading) return;
      const targetDate = new Date(this.weekAnchor);
      targetDate.setDate(targetDate.getDate() + offset * 7);
      this.weekLoading = true;
      try {
        await this.loadWeekData(targetDate);
        this.weekAnchor = targetDate;
        await this.selectDate(this.weekDays[0].dateKey);
      } finally {
        this.weekLoading = false;
      }
    },
    async navigateToCalendarMonth(date) {
      if (this.calendarLoading) return;
      this.lastCalendarClickDate = "";
      const targetDate = new Date(date.getFullYear(), date.getMonth(), 1);
      this.calendarLoading = true;
      try {
        await this.loadCalendarData(targetDate);
        this.calendarDate = targetDate;
        await this.selectDate(this.formatDateKey(targetDate));
      } finally {
        this.calendarLoading = false;
      }
    },
    async changeMonth(offset) {
      await this.navigateToCalendarMonth(
        new Date(
          this.calendarDate.getFullYear(),
          this.calendarDate.getMonth() + offset,
          1
        )
      );
    },
    async selectCalendarMonth(date) {
      if (!(date instanceof Date) || Number.isNaN(date.getTime())) return;
      await this.navigateToCalendarMonth(date);
    },
    async goToToday() {
      const date = new Date();
      if (this.periodMode === "week") {
        if (this.weekLoading) return;
        this.weekLoading = true;
        try {
          await this.loadWeekData(date);
          this.weekAnchor = new Date(date);
          this.calendarDate = new Date(date);
          await this.selectDate(this.formatDateKey(date));
        } finally {
          this.weekLoading = false;
        }
        return;
      }
      this.selectedDate = this.formatDateKey(date);
      this.weekAnchor = new Date(date);
      this.calendarDate = new Date(date);
      this.loading = true;
      try {
        await this.loadCalendarData();
        await this.loadSelectedDateData();
      } finally {
        this.loading = false;
      }
    },
    normalizeMealName(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/g, "d")
        .toLowerCase()
        .trim();
    },
    findDefaultMeal(foods) {
      const matches = (foods || []).filter(
        food => this.normalizeMealName(food.name) === "com suat"
      );
      return (
        matches.find(food => Number(food.price) === 35000) || matches[0] || null
      );
    },
    isDefaultMealName(name) {
      return this.normalizeMealName(name) === "com suat";
    },
    isFoodSelected(id) {
      return this.selectedFoodIds.includes(id);
    },
    toggleFood(id) {
      if (this.isFoodSelected(id)) {
        this.selectedFoodIds = this.selectedFoodIds.filter(
          value => value !== id
        );
        this.$delete(this.selectedFoodQuantities, id);
      } else {
        this.selectedFoodIds = [...this.selectedFoodIds, id];
        this.$set(this.selectedFoodQuantities, id, 1);
      }
    },
    setFoodQuantity(id, value) {
      this.$set(
        this.selectedFoodQuantities,
        id,
        Math.max(Number(value) || 1, 1)
      );
    },
    async refreshAfterMutation(key) {
      await this.loadMonthKeyData(key.slice(0, 7));
      if (key === this.selectedDate) await this.loadSelectedDateData();
    },
    async submitRegistration() {
      if (!this.selectedFoodIds.length) return;
      const wasRegistered = this.hasRegistration;
      if (wasRegistered && !this.canEditCurrentRegistration) {
        this.showModificationDeadlineAlert();
        return;
      }
      if (!wasRegistered && this.isRegistrationClosed(this.selectedDate)) {
        this.showToast("warning", this.registrationClosedMessage);
        return;
      }
      const items = this.selectedFoodIds.map(foodId => ({
        foodId,
        quantity: this.selectedFoodQuantities[foodId] || 1
      }));
      this.savingRegistration = true;
      try {
        await (wasRegistered
          ? LunchApi.updateMyRegistration(
              this.selectedDate,
              items,
              this.note || ""
            )
          : LunchApi.createRegistration(
              this.selectedDate,
              items,
              this.note || ""
            ));
        await this.refreshAfterMutation(this.selectedDate);
        this.registrationDialogVisible = false;
        this.showToast(
          "success",
          wasRegistered
            ? "Cập nhật đăng ký cơm thành công"
            : "Đăng ký cơm thành công"
        );
      } catch (error) {
        this.showApiError(error, "Không lưu được đăng ký cơm.");
      } finally {
        this.savingRegistration = false;
      }
    },
    cancelRegistration() {
      if (!this.canCancelCurrentRegistration) {
        this.showModificationDeadlineAlert();
        return;
      }
      this.confirmAction(
        "Bạn có chắc muốn hủy đăng ký cơm trưa ngày này?",
        "Hủy đăng ký",
        async () => {
          this.loading = true;
          try {
            await LunchApi.cancelMyRegistration(this.selectedDate);
            await this.refreshAfterMutation(this.selectedDate);
            this.showToast("success", "Đã hủy đăng ký cơm");
          } catch (error) {
            this.showApiError(error, "Không hủy được đăng ký cơm.");
          } finally {
            this.loading = false;
          }
        }
      );
    },
    applyBulkRegistrations(registrations) {
      if (!registrations || !registrations.length) return;
      const registeredDates = new Set(
        registrations.map(registration => registration.date)
      );
      this.registrationSummaries = this.registrationSummaries
        .filter(summary => !registeredDates.has(summary.date))
        .concat(
          registrations.map(registration => ({
            date: registration.date,
            status: registration.status,
            total_amount: registration.totalAmount,
            item_count: registration.items.reduce(
              (sum, item) => sum + Number(item.quantity || 0),
              0
            )
          }))
        );

      const selectedRegistration = registrations.find(
        registration => registration.date === this.selectedDate
      );
      if (selectedRegistration) {
        this.currentRegistration = selectedRegistration;
        this.applyDraft();
      }
    },
    registerCurrentWeek() {
      const candidateDates = this.workingWeekDays
        .filter(day => !day.isRegistered && !day.isRegistrationClosed)
        .map(day => day.dateKey);
      if (!candidateDates.length) {
        this.showToast(
          "warning",
          "Không có ngày làm việc nào đủ điều kiện để đăng ký."
        );
        return;
      }

      return this.confirmAction(
        'Món ăn mặc định được đăng ký là <strong>“Cơm suất”</strong>. Bạn có thể thay đổi cho từng ngày bằng cách bấm vào ngày trong lịch.',
        "Xác nhận đăng ký cả tuần",
        async () => {
          this.bulkLoading = true;
          try {
            const result = await LunchApi.createMyRegistrationsByWeek(
              this.weekDays[0].dateKey
            );
            const registrations = result.registrations || [];
            const registeredCount = Number(result.registered_count || 0);
            const skippedCount = Array.isArray(result.skipped_dates)
              ? result.skipped_dates.length
              : 0;
            this.applyBulkRegistrations(registrations);

            if (registeredCount > 0) {
              this.showToast(
                skippedCount ? "warning" : "success",
                skippedCount
                  ? `Đã đăng ký ${registeredCount} ngày; bỏ qua ${skippedCount} ngày không đủ điều kiện.`
                  : `Đã đăng ký ${registeredCount} ngày trong tuần.`
              );
            } else {
              this.showToast(
                "warning",
                skippedCount
                  ? `Không có ngày nào được đăng ký; ${skippedCount} ngày không đủ điều kiện.`
                  : "Không có ngày nào cần đăng ký trong tuần."
              );
            }
          } catch (error) {
            this.showApiError(error, "Không đăng ký được cơm cả tuần.");
          } finally {
            this.bulkLoading = false;
          }
        },
        null,
        {
          customClass: "lunch-week-confirmation",
          dangerouslyUseHTMLString: true
        }
      );
    },
    openMonthConfirmation() {
      const candidateDays = this.monthWorkingDays.filter(
        day => !day.isRegistered && !day.isRegistrationClosed
      );
      if (!candidateDays.length) {
        this.showToast(
          "warning",
          "Không có ngày làm việc nào đủ điều kiện để đăng ký."
        );
        return;
      }

      const defaultFood = this.findDefaultMeal(this.currentMenu);
      const estimatedPrice = defaultFood ? Number(defaultFood.price || 0) : 35000;
      this.preparedBulkPlan = candidateDays.map(day => ({
        dateKey: day.dateKey,
        food: { price: estimatedPrice }
      }));
      this.monthConfirmationVisible = true;
    },
    async confirmMonthRegistration() {
      if (!this.preparedBulkPlan.length) return;
      this.bulkLoading = true;
      try {
        const result = await LunchApi.createMyRegistrationsByMonth(
          this.formatMonthKey(this.calendarDate)
        );
        const registrations = result.registrations || [];
        const registeredCount = Number(result.registered_count || 0);
        const skippedCount = Array.isArray(result.skipped_dates)
          ? result.skipped_dates.length
          : 0;
        this.applyBulkRegistrations(registrations);
        this.monthConfirmationVisible = false;
        if (registeredCount > 0) {
          this.showToast(
            skippedCount ? "warning" : "success",
            skippedCount
              ? `Đã đăng ký ${registeredCount} ngày; bỏ qua ${skippedCount} ngày không đủ điều kiện.`
              : `Đã đăng ký ${registeredCount} ngày trong tháng.`
          );
        } else {
          this.showToast(
            "warning",
            skippedCount
              ? `Không có ngày nào được đăng ký; ${skippedCount} ngày không đủ điều kiện.`
              : "Không có ngày nào cần đăng ký trong tháng."
          );
        }
      } catch (error) {
        this.showApiError(error, "Không đăng ký được cơm cả tháng.");
      } finally {
        this.bulkLoading = false;
      }
    },
    async confirmMonthCancellation() {
      if (this.cancelMonthLoading || !this.monthRegisteredCount) return;
      this.cancelMonthLoading = true;
      const month = this.formatMonthKey(this.calendarDate);
      try {
        const result = await LunchApi.cancelMyRegistrationsByMonth(month);
        await this.loadMonthKeyData(month);
        if (this.selectedDate.indexOf(`${month}-`) === 0) {
          await this.loadSelectedDateData();
        }
        this.cancelMonthDialogVisible = false;

        const cancelledCount = Number(result.cancelled_count || 0);
        const skippedCount = Array.isArray(result.skipped_dates)
          ? result.skipped_dates.length
          : 0;
        if (cancelledCount > 0) {
          this.showToast(
            skippedCount ? "warning" : "success",
            skippedCount
              ? `Đã hủy ${cancelledCount} ngày; giữ nguyên ${skippedCount} ngày không đủ điều kiện hủy.`
              : `Đã hủy đăng ký ${cancelledCount} ngày trong tháng.`
          );
        } else {
          this.showToast(
            "warning",
            skippedCount
              ? `Không có ngày nào đủ điều kiện hủy; ${skippedCount} ngày được giữ nguyên.`
              : "Không có đăng ký nào cần hủy trong tháng."
          );
        }
      } catch (error) {
        this.showApiError(error, "Không hủy được đăng ký cơm cả tháng.");
      } finally {
        this.cancelMonthLoading = false;
      }
    },
    cancelCurrentWeek() {
      const dates = this.weekRegisteredDates;
      if (!dates.length) return;
      return this.confirmAction(
        `Hủy toàn bộ ${dates.length} đăng ký trong tuần đang hiển thị?`,
        "Hủy cả tuần",
        async () => {
          this.cancelWeekLoading = true;
          try {
            const result = await LunchApi.cancelMyRegistrationsByWeek(
              this.weekDays[0].dateKey
            );
            await this.loadWeekData();
            await this.loadSelectedDateData();
            const cancelledCount = Number(result.cancelled_count || 0);
            const skippedCount = Array.isArray(result.skipped_dates)
              ? result.skipped_dates.length
              : 0;
            if (cancelledCount > 0) {
              this.showToast(
                skippedCount ? "warning" : "success",
                skippedCount
                  ? `Đã hủy ${cancelledCount} ngày; giữ nguyên ${skippedCount} ngày không đủ điều kiện hủy.`
                  : `Đã hủy ${cancelledCount} ngày trong tuần.`
              );
            } else {
              this.showToast(
                "warning",
                skippedCount
                  ? `Không có ngày nào đủ điều kiện hủy; ${skippedCount} ngày được giữ nguyên.`
                  : "Không có đăng ký nào cần hủy trong tuần."
              );
            }
          } catch (error) {
            this.showApiError(error, "Không hủy được đăng ký cơm cả tuần.");
          } finally {
            this.cancelWeekLoading = false;
          }
        }
      );
    },
    confirmAction(message, title, action, onCancel, options) {
      if (this.$confirm)
        this.$confirm(
          message,
          title,
          Object.assign(
            {
              confirmButtonText: "Xác nhận",
              cancelButtonText: "Quay lại",
              type: "warning"
            },
            options || {}
          )
        )
          .then(action)
          .catch(() => {
            if (onCancel) onCancel();
          });
      else if (window.confirm(message.replace(/<[^>]*>/g, ""))) action();
      else if (onCancel) onCancel();
    },
    showApiError(error, fallback) {
      this.showToast("error", this.getApiErrorMessage(error, fallback));
    },
    getApiErrorMessage(error, fallback) {
      const result = (error && error.result) || {},
        code =
          result.error_code ||
          result.code ||
          (error && (error.error_code || error.code)) ||
          "";
      const messages = {
        LUNCH_PERMISSION_DENIED:
          "Bạn không có quyền thao tác chức năng đăng ký cơm.",
        INVALID_LUNCH_DATE: "Ngày đăng ký cơm không hợp lệ.",
        LUNCH_REGISTRATION_DEADLINE_PASSED:
          "Đã quá hạn đăng ký, sửa hoặc hủy cơm trưa.",
        LUNCH_MENU_NOT_FOUND: "Chưa có thực đơn cho ngày này.",
        MENU_NOT_FOUND: "Chưa có thực đơn cho ngày này.",
        FOOD_NOT_IN_MENU: "Món ăn không thuộc thực đơn ngày đã chọn."
      };
      return (
        messages[code] || result.message || (error && error.message) || fallback
      );
    },
    showToast(type, message) {
      if (this.$message)
        this.$message({ type, message, duration: 3000, showClose: true });
    }
  }
};
</script>

<style lang="scss" scoped>
.lunch-registration-page {
  color: #11264d;
  font-family: UTM Avo;
  font-size: 15px;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding-right: 0;
  padding-left: 0;
  margin-bottom: 16px;
}
.header-primary {
  min-width: 0;
}
.header-title-row {
  display: flex;
  align-items: center;
  gap: 16px;
}
.page-header h4 {
  display: flex;
  align-items: center;
  gap: 11px;
  margin: 0;
  color: #0d2248;
  font-size: 20px;
  font-weight: 700;
}
.page-header h4 i {
  color: #ff5b21;
}
.page-header p {
  margin: 5px 0 0;
  color: #68758b;
  font-size: 15px;
}
.header-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 9px;
}
.header-actions button {
  min-height: 40px;
  border: 1px solid var(--orange);
  border-radius: 7px;
  background: var(--orange);
  color: #fff;
  cursor: pointer;
  font: inherit;
  font-size: 13px;
  padding: 8px 13px;
}
.header-actions button:hover,
.header-actions button:focus {
  border-color: var(--orange);
  background: #ffb482;
  color: #fff;
}
.header-actions button:active {
  background: #fd9b5a;
}
.page-content {
  min-height: 320px;
}
.registration-layout {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(320px, 1fr);
  align-items: start;
  gap: 14px;
}
.registration-main {
  min-width: 0;
}
.period-picker {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 12px;
}
.page-header .period-picker {
  flex-shrink: 0;
  margin-bottom: 0;
}
.period-picker label {
  margin: 0;
  font-weight: 600;
}
.period-picker .el-select {
  width: 155px;
}
::v-deep .period-picker .el-input__inner {
  height: 42px;
  padding-left: 38px;
  font-size: 15px;
}
::v-deep .period-picker .el-input__prefix {
  display: flex;
  align-items: center;
  color: #ff5b21;
}
.panel {
  border: 1px solid #e3e9f1;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 4px 18px rgba(17, 38, 77, 0.05);
  padding: 16px;
}
.quick-banner {
  position: relative;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  border: 1px solid #ffd49d;
  border-radius: 9px;
  background: linear-gradient(100deg, #fff9ef, #fff4e4);
  margin-bottom: 18px;
  padding: 12px 34px 12px 12px;
}
.quick-banner__image {
  width: 66px;
  height: 66px;
  border-radius: 50%;
  background: #fff;
  object-fit: cover;
  box-shadow: 0 3px 10px rgba(79, 47, 20, 0.16);
}
.quick-banner > div:nth-child(2) {
  display: grid;
  gap: 2px;
}
.quick-banner strong {
  font-size: 16px;
}
.quick-banner span {
  color: #68758b;
  font-size: 13px;
}
.banner-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.quick-banner__close {
  position: absolute;
  top: 8px;
  right: 9px;
  border: 0;
  background: transparent;
  color: #53627a;
  cursor: pointer;
}
::v-deep .el-button--primary {
  background: #ff5b21;
  border-color: #ff5b21;
}
::v-deep .el-button {
  min-height: 38px;
  border-radius: 7px;
  font-family: UTM Avo;
}
::v-deep .registration-add-button > span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.registration-plus {
  display: inline-flex;
  align-items: center;
  line-height: 1;
  font-weight: 400;
  transform: translateY(-1px);
}
.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 14px;
}
.section-head h5,
.meal-head h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}
.section-head > div > span,
.meal-head > div > span {
  display: inline-block;
  margin-top: 3px;
  color: #718097;
  font-size: 13px;
}
.date-nav {
  display: flex;
  align-items: center;
  gap: 7px;
}
.date-nav button {
  display: inline-flex;
  min-width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  border: 1px solid #dce3ed;
  border-radius: 7px;
  background: #fff;
  color: #19325b;
  cursor: pointer;
  font: inherit;
}
.date-nav button:hover {
  border-color: #ff7a4a;
  color: #ef4e20;
}
.date-nav .date-nav__label {
  min-width: 92px;
  font-size: 13px;
}
.week-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(120px, 1fr));
  gap: 8px;
  overflow-x: auto;
  padding: 2px 2px 4px;
}
.day-card {
  display: flex;
  min-width: 92px;
  min-height: 190px;
  flex-direction: column;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  background: #fff;
  cursor: pointer;
  padding: 11px 7px 8px;
}
.day-card:hover,
.day-card:focus {
  border-color: #ff9a70;
  outline: none;
}
.day-card.selected {
  border-color: #ff6b38;
  box-shadow: 0 0 0 2px rgba(255, 91, 33, 0.12);
}
.day-card.registered {
  background: #fbfffc;
}
.day-card.day-off {
  background: #f7f9fb;
}
.day-card.today {
  border-color: #ff8c60;
}
.day-card > strong {
  font-size: 14px;
}
.day-card > span {
  color: #637189;
  font-size: 13px;
}
.day-card__status {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
}
.day-card__status > span {
  color: #6b7a90;
  font-size: 13px;
}
.day-off-status {
  display: grid;
  justify-items: center;
  gap: 9px;
}
.day-off-status i {
  display: inline-flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #e8edf3;
  color: #718097;
  font-size: 19px;
}
.deadline-status {
  display: grid;
  justify-items: center;
  gap: 7px;
  color: #d97706 !important;
}
.deadline-status i {
  font-size: 25px;
}
.day-card.expired {
  background: #fffaf3;
}
.day-card__status > .registered-status {
  display: grid;
  justify-items: center;
  gap: 7px;
  color: #0ca65b;
  font-weight: 600;
}
.day-card .el-button {
  width: 100%;
  min-width: 0;
  padding: 10px 4px;
  white-space: normal;
  line-height: 1.4;
  margin: 0;
  border-color: #ff7545;
  color: #ef4e20;
}
.status {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  font-size: 12px;
}
.status--ok {
  background: #0ca65b;
}
.status--cancel {
  background: #ed1c24;
}
.status--deadline {
  background: #f59e0b;
}
.week-summary {
  display: flex;
  align-items: center;
  gap: 18px;
  border-top: 1px solid #e8edf3;
  margin-top: 13px;
  padding-top: 13px;
}
.week-summary > span:first-child {
  color: #5b687d;
}
.week-head-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
}
.week-head-actions .el-button {
  margin-left: 0;
}
.danger-button {
  border-color: #ff817c !important;
  color: #d92a27 !important;
}
.month-head {
  align-items: flex-end;
}
.month-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
}
.month-actions .el-button {
  margin-left: 0;
}
.bulk-cancel-button.is-disabled,
.bulk-cancel-button.is-disabled:hover {
  border-color: #d8dee8 !important;
  background: #f5f7fa !important;
  color: #a9b2c2 !important;
}
.month-actions .date-nav__month-picker {
  min-width: 150px;
  width: 150px;
}
::v-deep .date-nav__month-picker .el-input__inner {
  height: 38px;
  border-color: #d9e0ea;
  border-radius: 7px;
  color: #314665;
  font-family: UTM Avo;
  font-size: 13px;
  padding-right: 30px;
  padding-left: 12px;
  text-align: center;
}
::v-deep .date-nav__month-picker .el-input__prefix {
  display: none;
}
::v-deep .date-nav__month-picker .el-input__suffix {
  display: flex;
  align-items: center;
}
.cancel-month-confirmation {
  color: #253858;
  line-height: 1.6;
}
.cancel-month-confirmation p {
  margin: 10px 0 0;
  color: #73809a;
}
.calendar {
  border: 1px solid #e5eaf1;
  border-radius: 9px;
  overflow: hidden;
}
.calendar-weekdays,
.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(75px, 1fr));
}
.calendar-weekdays {
  background: #f7f9fc;
}
.calendar-weekdays span {
  padding: 11px 4px;
  color: #425574;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.calendar-grid {
  gap: 1px;
  background: #e8edf3;
}
.calendar-day {
  display: flex;
  min-height: 82px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 2px solid transparent;
  background: #fff;
  color: #19325b;
  cursor: pointer;
  font: inherit;
}
.calendar-day:hover:not(:disabled) {
  border-color: #ffb08f;
}
.calendar-day.placeholder {
  visibility: hidden;
}
.calendar-day.registered {
  background: #ebfbf1;
}
.calendar-day.cancelled {
  background: #fff4f4;
}
.calendar-day.day-off:not(.registered):not(.cancelled) {
  background: #f5f7fa;
  color: #8290a5;
}
.calendar-day.today {
  border-color: #ff6b38;
  background: #fff9f0;
}
.calendar-day.selected {
  box-shadow: inset 0 0 0 2px #ff6b38;
}
.calendar-day > span {
  color: #718097;
  font-size: 12px;
}
.calendar-day .today-text {
  color: #ef4e20;
  font-weight: 600;
}
.calendar-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 13px;
}
.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  color: #53627a;
  font-size: 13px;
}
.legend span {
  display: flex;
  align-items: center;
  gap: 6px;
}
.legend .status,
.legend-off {
  width: 18px;
  height: 18px;
  font-size: 9px;
}
.legend-off {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #e7ebf0;
  color: #789;
}
.month-total {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  color: #5f6d82;
  font-size: 13px;
  white-space: nowrap;
}
.meal-panel {
  position: sticky;
  top: 82px;
  min-width: 0;
}
.meal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  background: #f0f2f5;
  color: #68758b;
  font-size: 13px;
  font-weight: 600;
  padding: 7px 12px;
}
.pill--ok {
  background: #e9f9ef;
  color: #078c4b;
}
.meal-body {
  display: grid;
  gap: 14px;
}
.meal-table {
  overflow: hidden;
  border: 1px solid #ffe1b5;
  border-radius: 8px;
  background: #fff;
}
.meal-table__header,
.meal-table__row {
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(76px, 0.8fr) minmax(
      108px,
      0.9fr
    );
  align-items: center;
  gap: 8px;
}
.meal-table__header {
  border-bottom: 1px solid #ffe1b5;
  background: #fff;
  color: #596a83;
  font-size: 12px;
  padding: 10px 12px;
}
.meal-table__header span:nth-child(2),
.meal-table__header span:nth-child(3) {
  text-align: center;
}
.meal-table__row {
  min-height: 60px;
  box-sizing: border-box;
  border-bottom: 1px solid #ffe1b5;
  background: #fff8e9;
  padding: 10px;
}
.meal-table__row:last-child {
  border-bottom: 0;
}
.meal-table__list {
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
}
.meal-table__list::-webkit-scrollbar {
  width: 6px;
}
.meal-table__list::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: #ff9b62;
}
.meal-table__list::-webkit-scrollbar-track {
  background: transparent;
}
.meal-table__name {
  display: flex;
  min-width: 0;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 3px;
}
.meal-table__name strong {
  overflow: hidden;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.meal-table__name span {
  color: #69778c;
  font-size: 11px;
}
.meal-table__price {
  font-size: 13px;
  text-align: center;
  white-space: nowrap;
}
.meal-table__quantity {
  color: #17335d;
  font-size: 14px;
  text-align: center;
}
.quantity-display {
  display: grid;
  grid-template-columns: 34px 36px 34px;
  justify-content: center;
}
.quantity-display button,
.quantity-display span {
  display: flex;
  height: 38px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d8e0eb;
  background: #fff;
  color: #17335d;
  font: inherit;
}
.quantity-display button {
  cursor: pointer;
  font-size: 19px;
}
.quantity-display button:first-child {
  border-radius: 6px 0 0 6px;
}
.quantity-display button:last-child {
  border-radius: 0 6px 6px 0;
}
.quantity-display span {
  border-right: 0;
  border-left: 0;
  font-weight: 600;
}
.meal-note-label {
  margin-bottom: -7px;
  color: #455975;
  font-size: 13px;
  font-weight: 600;
}
.meal-note-display {
  min-height: 86px;
  box-sizing: border-box;
  border-color: #d9e1ec;
  border-style: solid;
  border-width: 1px;
  border-radius: 4px;
  background: #f8fafc;
  color: #263a5d;
  font-family: UTM Avo;
  font-size: 13px;
  line-height: 1.6;
  padding: 10px 12px;
  white-space: pre-wrap;
  word-break: break-word;
}
.meal-note-display--empty {
  color: #8190a6;
  font-style: italic;
}
.meal-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #e8edf3;
  padding-top: 13px;
  font-size: 15px;
}
.meal-total strong {
  color: #0f2852;
  font-size: 17px;
}
.meal-actions {
  display: flex;
  width: 100%;
  max-width: 100%;
  align-items: stretch;
  flex-shrink: 0;
  gap: 12px;
}
.meal-action-button {
  display: inline-flex;
  height: 44px;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 7px;
  margin-left: 0 !important;
  padding-top: 0;
  padding-bottom: 0;
  line-height: 1.2;
  white-space: nowrap;
}
.meal-action-button i {
  margin: 0;
  line-height: 1;
}
.meal-action-button--edit {
  flex: 1 1 auto;
  border-color: #ff5b21;
  background: #ff5b21;
  color: #fff;
}
.meal-action-button--edit:hover,
.meal-action-button--edit:focus {
  border-color: #ef4e20;
  background: #ef4e20;
  color: #fff;
}
.meal-action-button--cancel {
  width: auto;
  min-width: 170px;
  flex: 0 0 auto;
  padding-right: 18px;
  padding-left: 18px;
}
.empty-meal {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-radius: 8px;
  background: #f8fafc;
  padding: 13px;
}
.empty-meal > div {
  display: grid;
  gap: 3px;
}
.empty-meal span {
  color: #68758b;
}
.expired-meal {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #f5d39a;
  border-radius: 8px;
  background: #fffaf0;
  padding: 16px;
}
.expired-meal > i {
  color: #e78a13;
  font-size: 28px;
}
.expired-meal > div {
  display: grid;
  gap: 4px;
}
.expired-meal span {
  color: #68758b;
  font-size: 13px;
}
.notice,
.warning {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  border: 1px solid #ffd18d;
  border-radius: 8px;
  background: #fff8e9;
  color: #70511e;
  line-height: 1.5;
  margin-bottom: 14px;
  padding: 11px 13px;
}
.notice i,
.warning i {
  color: #f08a20;
  margin-top: 3px;
}
.empty-state {
  border: 1px dashed #cfd7e3;
  border-radius: 8px;
  color: #69778c;
  padding: 24px;
  text-align: center;
}
.settings-form {
  display: grid;
  gap: 10px;
}
.settings-form h5 {
  margin: 0 0 6px;
  color: #11264d;
  font-size: 17px;
}
.settings-form label {
  font-weight: 600;
}
.settings-form p {
  margin: 2px 0 0;
  color: #68758b;
  line-height: 1.55;
}
::v-deep .settings-form .el-date-editor.el-input {
  width: 180px;
}
::v-deep .settings-form .el-input__inner {
  height: 46px;
  font-size: 18px;
  font-weight: 600;
}
.food-grid {
  display: grid;
  min-height: 140px;
  flex: 0 1 auto;
  grid-template-columns: repeat(auto-fill, minmax(145px, 1fr));
  gap: 12px;
  max-height: 350px;
  overflow-y: auto;
  padding: 3px;
}
.registration-section-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}
.registration-section-heading h6 {
  margin: 0;
  color: #11264d;
  font-size: 15px;
  font-weight: 700;
}
.registration-section-heading p {
  margin: 3px 0 0;
  color: #768398;
  font-size: 12px;
}
.registration-section-heading > span {
  flex: none;
  border-radius: 14px;
  background: #fff1e8;
  color: #ef4e20;
  font-size: 12px;
  padding: 5px 10px;
}
.food-card {
  position: relative;
  display: flex;
  min-width: 0;
  flex-direction: column;
  overflow: hidden;
  border: 2px solid #e2e7ee;
  border-radius: 10px;
  background: #fff;
  color: #172f56;
  cursor: pointer;
  font-family: UTM Avo;
  padding: 0 0 10px;
  text-align: center;
  transition: border-color 0.2s ease, box-shadow 0.2s ease,
    transform 0.2s ease;
}
.food-card:hover {
  border-color: #ff9b75;
  box-shadow: 0 6px 16px rgba(17, 38, 77, 0.08);
  transform: translateY(-1px);
}
.food-card.selected {
  border-color: #ff5b21;
  background: #fff8f3;
  box-shadow: 0 0 0 2px rgba(255, 91, 33, 0.1);
}
.food-card > div {
  position: relative;
  height: 98px;
  margin-bottom: 9px;
  overflow: hidden;
}
.food-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.food-card > div i {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  width: 23px;
  height: 23px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #ff5b21;
  color: #fff;
}
.food-card strong {
  overflow: hidden;
  padding: 0 5px;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.food-card > span {
  margin-top: 2px;
  font-size: 12px;
  font-weight: 600;
}
.order-options {
  display: grid;
  min-height: 160px;
  max-height: 336px;
  flex: 0 1 auto;
  gap: 10px;
  grid-template-rows: auto minmax(0, 1fr) auto auto;
  border: 1px solid #e5eaf1;
  border-radius: 12px;
  background: #f8fafc;
  margin-top: 18px;
  padding: 15px;
}
.order-options__heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  color: #11264d;
}
.order-options__heading strong {
  font-size: 14px;
}
.selected-food-table {
  display: flex;
  min-height: 0;
  max-height: 260px;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #f2d9c7;
  border-radius: 9px;
  background: #fff;
}
.selected-food-table__header,
.quantity-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 100px 128px;
  align-items: center;
  gap: 12px;
}
.selected-food-table__header {
  flex: none;
  background: #fff;
  color: #69778c;
  font-size: 12px;
  padding: 9px 12px;
}
.selected-food-table__list {
  min-height: 0;
  flex: 1 1 auto;
  overflow-x: hidden;
  overflow-y: auto;
}
.selected-food-table__list::-webkit-scrollbar {
  width: 6px;
}
.selected-food-table__list::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: #ff9b62;
}
.selected-food-table__list::-webkit-scrollbar-track {
  background: transparent;
}
.selected-food-table__header span:nth-child(2),
.selected-food-table__header span:nth-child(3) {
  text-align: center;
}
.quantity-row {
  min-height: 58px;
  border-top: 1px solid #f2d9c7;
  background: #fff8e9;
  padding: 8px 12px;
}
.selected-food-name {
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 4px;
}
.selected-food-name strong {
  min-width: 0;
  overflow: hidden;
  color: #263a5d;
  font-size: 14px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.selected-food-name span {
  flex: none;
  color: #768398;
  font-size: 11px;
}
.selected-food-price {
  color: #11264d;
  font-size: 13px;
  text-align: center;
  white-space: nowrap;
}
.quantity-control {
  display: flex;
  width: 100%;
  align-items: center;
  align-self: stretch;
  justify-content: center;
}
.quantity-editor button:disabled {
  background: #f5f7fa;
  color: #c0c4cc;
  cursor: not-allowed;
}
.dialog-note-field {
  display: grid;
  grid-template-columns: 145px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
}
.dialog-note-field label {
  margin: 0;
  color: #455975;
  font-size: 13px;
  font-weight: 600;
}
::v-deep .dialog-note-field .el-input__inner {
  height: 38px;
  border-color: #d9e1ec;
  font-family: UTM Avo;
}
.dialog-total {
  display: flex;
  min-height: 48px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-radius: 8px;
  background: #fff3ea;
  color: #263a5d;
  font-size: 15px;
  margin-top: 2px;
  padding: 0 14px;
}
.dialog-total strong {
  color: #11264d;
  font-size: 17px;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.dialog-footer .el-button {
  min-width: 120px;
  margin: 0;
}
.month-default-meal-note {
  color: #344563;
  font-size: 16px;
  line-height: 1.55;
  margin: 0 0 14px;
}
.month-default-meal-note strong {
  color: #e55220;
  font-weight: 700;
}
.month-registration-notice {
  border: 0;
  border-radius: 0;
  background: transparent;
  padding: 0;
}
.confirm-stats {
  display: grid;
  gap: 9px;
  border: 1px solid #ffd292;
  border-radius: 8px;
  background: #fff8ea;
  margin: 14px 0;
  padding: 13px 16px;
}
.confirm-stats span {
  display: flex;
  align-items: center;
  gap: 8px;
}
.confirm-stats i {
  width: 18px;
  color: #ff5b21;
}
::v-deep .lunch-dialog {
  border-radius: 10px;
  font-family: UTM Avo;
}
::v-deep .lunch-dialog .el-dialog__title {
  color: #11264d;
  font-size: 18px;
  font-weight: 700;
}
::v-deep .lunch-settings-dialog .el-dialog__title {
  color: #fff;
}
::v-deep .lunch-month-confirmation-dialog .el-dialog__title {
  color: #fff;
}
::v-deep .lunch-dialog .el-dialog__body {
  max-height: calc(100vh - 190px);
  overflow-y: auto;
  padding-top: 10px;
}
::v-deep .lunch-registration-dialog {
  display: flex;
  max-height: calc(100vh - 64px);
  flex-direction: column;
  overflow: hidden;
  border-radius: 14px;
  margin-top: 32px !important;
  margin-bottom: 32px;
  box-shadow: 0 16px 42px rgba(17, 38, 77, 0.2);
}
::v-deep .lunch-registration-dialog .el-dialog__header {
  flex: none;
  border-bottom: 1px solid #f1e2d8;
  background: linear-gradient(135deg, #fff4ec 0%, #fffaf7 100%);
  padding: 17px 52px 16px 22px;
}
::v-deep .lunch-registration-dialog .el-dialog__headerbtn {
  top: 18px;
  right: 20px;
  font-size: 18px;
}
::v-deep .lunch-registration-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #ef6b42;
}
::v-deep .lunch-registration-dialog .el-dialog__body {
  display: flex;
  min-height: 0;
  max-height: none;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;
  padding: 18px 22px 20px;
}
::v-deep .lunch-registration-dialog .el-dialog__footer {
  flex: none;
  border-top: 1px solid #e8edf3;
  background: #fff;
  padding: 14px 22px 18px;
}
::v-deep .lunch-registration-dialog .dialog-footer .el-button {
  height: 42px;
  border-radius: 8px;
}
::v-deep .lunch-registration-dialog .dialog-footer .el-button--primary {
  border-color: #ff7a45;
  background: #ff7a45;
  box-shadow: 0 5px 12px rgba(255, 91, 33, 0.2);
}
@media (max-width: 1199px) {
  .page-header {
    flex-wrap: wrap;
  }
  .header-actions {
    width: 100%;
  }
  .registration-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .meal-panel {
    position: static;
  }
}
@media (max-width: 1100px) {
  .quick-banner {
    grid-template-columns: auto 1fr;
  }
  .banner-actions {
    grid-column: 1/-1;
    padding-left: 68px;
  }
  .week-grid {
    grid-template-columns: repeat(7, minmax(124px, 1fr));
  }
  .week-summary {
    flex-wrap: wrap;
  }
}
@media (max-width: 767px) {
  .page-header,
  .section-head,
  .calendar-footer,
  .meal-body {
    align-items: stretch;
    flex-direction: column;
  }
  .header-actions {
    justify-content: flex-start;
  }
  .header-actions button {
    flex: 1 1 190px;
  }
  .header-title-row {
    align-items: stretch;
    flex-direction: column;
    gap: 10px;
  }
  .period-picker {
    justify-content: space-between;
  }
  .quick-banner {
    grid-template-columns: 1fr;
    text-align: center;
  }
  .quick-banner__image {
    margin: auto;
  }
  .banner-actions {
    grid-column: auto;
    flex-direction: column;
    padding: 0;
  }
  .date-nav {
    justify-content: space-between;
  }
  .date-nav__label {
    flex: 1;
  }
  .date-nav__month-picker {
    flex: 1;
    width: auto;
  }
  .month-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .week-head-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .week-head-actions .el-button {
    width: 100%;
  }
  .calendar-weekdays,
  .calendar-grid {
    grid-template-columns: repeat(7, minmax(43px, 1fr));
  }
  .calendar-weekdays span {
    overflow: hidden;
    font-size: 10px;
    padding: 8px 2px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .calendar-day {
    min-height: 62px;
    gap: 5px;
    font-size: 13px;
  }
  .calendar-day > span {
    font-size: 10px;
  }
  .month-total {
    align-items: flex-start;
  }
  .meal-actions {
    flex-direction: column;
  }
  .meal-action-button--edit,
  .meal-action-button--cancel {
    width: 100%;
    min-width: 0;
    flex: none;
  }
  .empty-meal {
    align-items: stretch;
    flex-direction: column;
  }
  ::v-deep .lunch-dialog {
    width: calc(100% - 24px) !important;
    margin-top: 4vh !important;
  }
  ::v-deep .lunch-registration-dialog {
    margin-top: 32px !important;
  }
  .food-grid {
    min-height: 120px;
  }
  .order-options {
    min-height: 145px;
  }
}
@media (max-width: 480px) {
  .panel {
    padding: 12px;
  }
  .page-header h4 {
    font-size: 20px;
  }
  .page-header p {
    margin-left: 0;
  }
  .week-grid {
    display: flex;
  }
  .day-card {
    min-width: 145px;
  }
  .calendar-day {
    min-height: 53px;
  }
  .calendar-day > span {
    display: none;
  }
  .calendar-day .status {
    width: 19px;
    height: 19px;
    font-size: 10px;
  }
  .week-summary {
    align-items: stretch;
    flex-direction: column;
    gap: 10px;
  }
  .selected-food-table__header,
  .quantity-row {
    grid-template-columns: minmax(0, 1fr) 76px 104px;
    gap: 6px;
    padding-right: 8px;
    padding-left: 8px;
  }
  .selected-food-name span {
    display: none;
  }
}
</style>

<style lang="scss">
.lunch-week-confirmation {
  overflow: hidden;
  border: none;
  border-radius: 10px;
  font-family: UTM Avo;
}

.lunch-week-confirmation .el-message-box__header {
  background: var(--orange);
  padding: 15px 20px;
}

.lunch-week-confirmation .el-message-box__title {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
}

.lunch-week-confirmation .el-message-box__headerbtn {
  top: 15px;
  right: 18px;
}

.lunch-week-confirmation .el-message-box__headerbtn .el-message-box__close {
  color: #fff;
}

.lunch-week-confirmation .el-message-box__headerbtn:hover .el-message-box__close,
.lunch-week-confirmation .el-message-box__headerbtn:focus .el-message-box__close {
  color: #fff;
  opacity: 0.78;
}

.lunch-week-confirmation .el-message-box__status {
  display: none;
}

.lunch-week-confirmation .el-message-box__message {
  color: #344563;
  font-size: 16px;
  line-height: 1.55;
  padding-left: 0;
}

.lunch-week-confirmation .el-message-box__message strong {
  color: #e55220;
  font-weight: 700;
}
</style>
